import React from "react";
import { FlexCenter, FlexRowSB } from "../../../constant/CustomeStyle";
import DataTable from "./DataTable";
import DateRangeBar from "./DateRangeBar";
import RightMenu from "./RightMenu";

const WorkPeriod = () => {
  return (
    <FlexRowSB style={{}}>
      <div
        style={{
          marginTop: 30,
          width: 862,
        }}
      >
        <FlexCenter>
          <div style={{ width: 802 }}>
            <TopTitle />

            <div style={{ marginTop: 20 }}>
              <DateRangeBar />
            </div>

            <div style={{ marginTop: 10 }}>
              <DataTable />
            </div>
          </div>
        </FlexCenter>
      </div>

      <RightMenu />
    </FlexRowSB>
  );
};

const TopTitle = () => (
  <FlexCenter
    style={{
      width: "100%",
      height: 55.15,
      color: "#FFF",
      background: "#0E5A41",
      fontSize: 20,
      fontWeight: "600",
      fontFamily: `Poppins, sans-serif`,
    }}
  >
    Work Periods
  </FlexCenter>
);

export default WorkPeriod;
